export namespace EnumTypes {
    export enum RoleName {
        FLEET_OWNER = 'FLEET_OWNER',
        ADMIN = 'ADMIN',
        TECHNICIAN = 'TECHNICIAN',
        ALBATROSS = 'ALBATROSS',
        EXTERNAL = 'EXTERNAL',
    }
    export enum Status {
        NOT_ACTIVE = 'NOT_ACTIVE',
        ACTIVE = 'ACTIVE',
        BLOCKED = 'BLOCKED'
    }
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/UserEnumTypes.ts